// FollowUpForm.jsx
import React, { useState, useEffect, useRef, useMemo } from 'react';
import Spinner from '../Spinner/spinner';
import SpinnerOverlay from '../Spinner/spinneroverlay';
import { useHistory } from 'react-router-dom';
import './qa.css';
import axios from 'axios';
import config from '../../config';
import { trackFormSubmission } from '../../utils/analytics';
import { useLanguage } from '../../i18n/LanguageContext';

const STATIC_SUGGESTION_TRANSLATIONS = {
  no: {
    'Ja, hela bostaden renoverades för 3 år sedan': 'Ja, hele boligen ble renovert for 3 år siden',
    'Köket renoverades 2020 och badrummet 2022': 'Kjøkkenet ble renovert i 2020 og badet i 2022',
    'Inga större renoveringar har gjorts nyligen': 'Ingen større oppussinger er gjort nylig',
    'Delvis renoverat - kök och badrum är i originalskick': 'Delvis oppusset - kjøkken og bad er i original stand',
    'Bostaden har bra planlösning med öppna ytor': 'Boligen har god planløsning med åpne rom',
    'Den är ljus med stora fönster i vardagsrummet': 'Den er lys med store vinduer i stuen',
    'Köket är nyligen renoverat med modern standard': 'Kjøkkenet er nylig renovert med moderne standard',
    'Den har en praktisk planlösning med bra förvaring': 'Den har en praktisk planløsning med god oppbevaring',
    'Området är lugnt och barnvänligt med nähet till skolor': 'Området er rolig og barnevennlig med nærhet til skoler',
    'Det finns bra kommunikationer med bussar och tunnelbana': 'Det er gode forbindelser med busser og T-bane',
    'Det är nära till matbutiker och service': 'Det er kort vei til matbutikker og service',
    'Området har många grönområden och parker': 'Området har mange grøntområder og parker',
    'Driftskostnaderna är ca 3000-4000 kr per månad': 'Driftskostnadene er ca. 3000-4000 kr per måned',
    'El, värme och vatten kostar ca 2500 kr per månad': 'Strøm, varme og vann koster ca. 2500 kr per måned',
    'Jag uppskattar att driftskostnaderna är normala för denna typ av bostad': 'Jeg anslår at driftskostnadene er normale for denne typen bolig',
    'Förra årets totala driftskostnader var ca 30 000 kr': 'Fjorårets totale driftskostnader var ca. 30 000 kr',
    'Ja, det finns en balkong i söderläge med plats för möbler': 'Ja, det finnes en sydvendt balkong med plass til møbler',
    'Lägenheten har en inglasad balkong på 6 kvm': 'Leiligheten har en innglasset balkong på 6 kvm',
    'Nej, det finns ingen balkong eller uteplats': 'Nei, det finnes ingen balkong eller uteplass',
    'Det finns en gemensam innergård med utemöbler': 'Det finnes en felles bakgård med utemøbler',
    'Månadsavgiften är 3500 kr och inkluderar värme och vatten': 'Månedsavgiften er 3500 kr og inkluderer varme og vann',
    'Avgiften är 4200 kr och inkluderar bredband och kabel-TV': 'Avgiften er 4200 kr og inkluderer bredbånd og kabel-TV',
    'Månadsavgiften är 2800 kr, exklusive el': 'Månedsavgiften er 2800 kr, ekskludert strøm',
    'Avgiften på 3900 kr inkluderar alla nödvändiga kostnader': 'Avgiften på 3900 kr inkluderer alle nødvendige kostnader',
    'Föreningen är ekonomiskt stabil med låg belåning': 'Sameiet/borettslaget er økonomisk stabilt med lav belåning',
    'Det finns inga planerade avgiftshöjningar': 'Det er ingen planlagte avgiftsøkninger',
    'Föreningen äger marken och har god ekonomi': 'Sameiet/borettslaget eier tomten og har god økonomi',
    'Föreningen har nyligen genomfört stambyten och takrenovering': 'Sameiet/borettslaget har nylig gjennomført rørutskifting og takrenovering',
    'Tomten är 850 kvm med en välskött trädgård': 'Tomten er 850 kvm med en velstelt hage',
    'Det finns en stor trädgård med fruktträd och planteringar': 'Det finnes en stor hage med frukttrær og beplantning',
    'Trädgården är lättskött med gräsmatta och stenlagd uteplats': 'Hagen er lettstelt med plen og steinlagt uteplass',
    'Tomten är hörntomt på 1200 kvm med soligt läge': 'Tomten er en hjørnetomt på 1200 kvm med solrik beliggenhet',
    'Ja, det finns ett garage med plats för en bil plus uppfart': 'Ja, det finnes en garasje med plass til én bil samt oppkjørsel',
    'Det finns carport med plats för två bilar': 'Det finnes carport med plass til to biler',
    'Nej, men det finns gott om parkeringsmöjligheter på gatan': 'Nei, men det er gode parkeringsmuligheter i gaten',
    'Ja, det finns ett fristående dubbelgarage på tomten': 'Ja, det finnes en frittstående dobbeltgarasje på tomten',
    'Huset värms upp med fjärrvärme, energiklass C': 'Huset varmes opp med fjernvarme, energiklasse C',
    'Det finns bergvärme installerad 2019 som ger låga driftskostnader': 'Det er installert bergvarme i 2019 som gir lave driftskostnader',
    'Luftvärmepump kompletterar direktverkande el för uppvärmning': 'Luftvarmepumpe supplerer direkte elektrisk oppvarming',
    'Huset har vattenburen golvvärme på nedervåningen': 'Huset har vannbåren gulvvarme i underetasjen',
    'Ja, huset är vinterbonat och kan användas året runt': 'Ja, huset er vinterisolert og kan brukes året rundt',
    'Delvis, men uppvärmningskostnaderna blir höga på vintern': 'Delvis, men oppvarmingskostnadene blir høye om vinteren',
    'Nej, det är främst ett sommarhus med enkel standard': 'Nei, det er først og fremst en sommerhytte med enkel standard',
    'Huset har förstärkts isolering och nya fönster för åretruntbruk': 'Huset har forbedret isolasjon og nye vinduer for helårsbruk',
    'Det är 200 meter till stranden med egen båtplats': 'Det er 200 meter til stranden med egen båtplass',
    'Fritidshuset ligger precis vid sjön med egen brygga': 'Fritidsboligen ligger rett ved sjøen med egen brygge',
    'Tomten gränsar till havet med fantastisk utsikt': 'Tomten grenser mot havet med fantastisk utsikt',
    'Det är cirka 500 meter till närmaste badplats': 'Det er ca. 500 meter til nærmeste badeplass',
    'Det finns kommunalt vatten men eget avlopp med trekammarbrunn': 'Det finnes kommunalt vann, men eget avløp med trekammerbrønn',
    'Huset har egen brunn och infiltrationsanläggning från 2018': 'Huset har egen brønn og infiltrasjonsanlegg fra 2018',
    'Det är anslutit till kommunalt vatten och avlopp': 'Det er tilkoblet kommunalt vann og avløp',
    'Det finns sommarvatten indraget men torrtoa': 'Det er innlagt sommervann, men tørrtoalett',
    'Bostaden är i mycket gott skick utan renoveringsbehov': 'Boligen er i svært god stand uten behov for oppussing',
    'Det finns visst renoveringsbehov i badrum och kök': 'Det er noe oppussingsbehov på bad og kjøkken',
    'Allt är välskött men i äldre standard': 'Alt er godt vedlikeholdt, men har eldre standard',
    'Bostaden håller genomgående hög standard': 'Boligen holder gjennomgående høy standard',
    'Ja, det stämmer': 'Ja, det stemmer',
    'Nej, det stämmer inte': 'Nei, det stemmer ikke',
    'Jag är osäker på det': 'Jeg er usikker på det',
    'Kan du specificera frågan lite mer?': 'Kan du spesifisere spørsmålet litt mer?'
  },
  dk: {
    'Ja, hela bostaden renoverades för 3 år sedan': 'Ja, hele boligen blev renoveret for 3 år siden',
    'Köket renoverades 2020 och badrummet 2022': 'Køkkenet blev renoveret i 2020 og badeværelset i 2022',
    'Inga större renoveringar har gjorts nyligen': 'Der er ikke lavet større renoveringer for nylig',
    'Delvis renoverat - kök och badrum är i originalskick': 'Delvist renoveret - køkken og badeværelse er i original stand',
    'Bostaden har bra planlösning med öppna ytor': 'Boligen har en god planløsning med åbne rum',
    'Den är ljus med stora fönster i vardagsrummet': 'Den er lys med store vinduer i stuen',
    'Köket är nyligen renoverat med modern standard': 'Køkkenet er nyligt renoveret med moderne standard',
    'Den har en praktisk planlösning med bra förvaring': 'Den har en praktisk planløsning med god opbevaring',
    'Området är lugnt och barnvänligt med nähet till skolor': 'Området er roligt og børnevenligt med nærhed til skoler',
    'Det finns bra kommunikationer med bussar och tunnelbana': 'Der er gode forbindelser med busser og metro',
    'Det är nära till matbutiker och service': 'Der er kort afstand til dagligvarebutikker og service',
    'Området har många grönområden och parker': 'Området har mange grønne områder og parker',
    'Driftskostnaderna är ca 3000-4000 kr per månad': 'Driftsomkostningerne er ca. 3000-4000 kr. pr. måned',
    'El, värme och vatten kostar ca 2500 kr per månad': 'El, varme og vand koster ca. 2500 kr. pr. måned',
    'Jag uppskattar att driftskostnaderna är normala för denna typ av bostad': 'Jeg vurderer, at driftsomkostningerne er normale for denne type bolig',
    'Förra årets totala driftskostnader var ca 30 000 kr': 'Sidste års samlede driftsomkostninger var ca. 30 000 kr.',
    'Ja, det finns en balkong i söderläge med plats för möbler': 'Ja, der er en sydvendt altan med plads til møbler',
    'Lägenheten har en inglasad balkong på 6 kvm': 'Lejligheden har en indglasset altan på 6 kvm',
    'Nej, det finns ingen balkong eller uteplats': 'Nej, der er ingen altan eller terrasse',
    'Det finns en gemensam innergård med utemöbler': 'Der er en fælles gårdhave med havemøbler',
    'Månadsavgiften är 3500 kr och inkluderar värme och vatten': 'Den månedlige udgift er 3500 kr. og inkluderer varme og vand',
    'Avgiften är 4200 kr och inkluderar bredband och kabel-TV': 'Udgiften er 4200 kr. og inkluderer bredbånd og kabel-TV',
    'Månadsavgiften är 2800 kr, exklusive el': 'Den månedlige udgift er 2800 kr., eksklusive el',
    'Avgiften på 3900 kr inkluderar alla nödvändiga kostnader': 'Udgiften på 3900 kr. inkluderer alle nødvendige omkostninger',
    'Föreningen är ekonomiskt stabil med låg belåning': 'Foreningen er økonomisk stabil med lav belåning',
    'Det finns inga planerade avgiftshöjningar': 'Der er ingen planlagte afgiftsstigninger',
    'Föreningen äger marken och har god ekonomi': 'Foreningen ejer grunden og har god økonomi',
    'Föreningen har nyligen genomfört stambyten och takrenovering': 'Foreningen har for nylig gennemført rørudskiftning og tagrenovering',
    'Tomten är 850 kvm med en välskött trädgård': 'Grunden er 850 kvm med en velholdt have',
    'Det finns en stor trädgård med fruktträd och planteringar': 'Der er en stor have med frugttræer og beplantning',
    'Trädgården är lättskött med gräsmatta och stenlagd uteplats': 'Haven er nem at holde med græsplæne og stenlagt terrasse',
    'Tomten är hörntomt på 1200 kvm med soligt läge': 'Grunden er en hjørnegrund på 1200 kvm med solrig beliggenhed',
    'Ja, det finns ett garage med plats för en bil plus uppfart': 'Ja, der er en garage med plads til én bil samt indkørsel',
    'Det finns carport med plats för två bilar': 'Der er carport med plads til to biler',
    'Nej, men det finns gott om parkeringsmöjligheter på gatan': 'Nej, men der er gode parkeringsmuligheder på vejen',
    'Ja, det finns ett fristående dubbelgarage på tomten': 'Ja, der er en fritliggende dobbeltgarage på grunden',
    'Huset värms upp med fjärrvärme, energiklass C': 'Huset opvarmes med fjernvarme, energiklasse C',
    'Det finns bergvärme installerad 2019 som ger låga driftskostnader': 'Der er installeret jordvarme i 2019, som giver lave driftsomkostninger',
    'Luftvärmepump kompletterar direktverkande el för uppvärmning': 'Luftvarmepumpe supplerer direkte elvarme',
    'Huset har vattenburen golvvärme på nedervåningen': 'Huset har vandbåren gulvvarme i stueetagen',
    'Ja, huset är vinterbonat och kan användas året runt': 'Ja, huset er vinterisoleret og kan bruges året rundt',
    'Delvis, men uppvärmningskostnaderna blir höga på vintern': 'Delvist, men opvarmningsomkostningerne bliver høje om vinteren',
    'Nej, det är främst ett sommarhus med enkel standard': 'Nej, det er primært et sommerhus med enkel standard',
    'Huset har förstärkts isolering och nya fönster för åretruntbruk': 'Huset har forbedret isolering og nye vinduer til helårsbrug',
    'Det är 200 meter till stranden med egen båtplats': 'Der er 200 meter til stranden med egen bådplads',
    'Fritidshuset ligger precis vid sjön med egen brygga': 'Fritidshuset ligger lige ved søen med egen bro',
    'Tomten gränsar till havet med fantastisk utsikt': 'Grunden grænser op til havet med fantastisk udsigt',
    'Det är cirka 500 meter till närmaste badplats': 'Der er cirka 500 meter til nærmeste badeplads',
    'Det finns kommunalt vatten men eget avlopp med trekammarbrunn': 'Der er kommunalt vand, men eget afløb med trekammertank',
    'Huset har egen brunn och infiltrationsanläggning från 2018': 'Huset har egen brønd og nedsivningsanlæg fra 2018',
    'Det är anslutit till kommunalt vatten och avlopp': 'Det er tilsluttet kommunalt vand og afløb',
    'Det finns sommarvatten indraget men torrtoa': 'Der er indlagt sommervand, men tørkloset',
    'Bostaden är i mycket gott skick utan renoveringsbehov': 'Boligen er i meget god stand uden renoveringsbehov',
    'Det finns visst renoveringsbehov i badrum och kök': 'Der er et vist renoveringsbehov i badeværelse og køkken',
    'Allt är välskött men i äldre standard': 'Alt er velholdt, men i ældre standard',
    'Bostaden håller genomgående hög standard': 'Boligen holder gennemgående høj standard',
    'Ja, det stämmer': 'Ja, det stemmer',
    'Nej, det stämmer inte': 'Nej, det stemmer ikke',
    'Jag är osäker på det': 'Jeg er usikker på det',
    'Kan du specificera frågan lite mer?': 'Kan du præcisere spørgsmålet lidt mere?'
  }
};

const localizeStaticSuggestions = (suggestions, language) => {
  if (language === 'sv') return suggestions;
  const translationsForLanguage = STATIC_SUGGESTION_TRANSLATIONS[language];
  if (!translationsForLanguage) return [];
  return suggestions
    .map((suggestion) => translationsForLanguage[suggestion])
    .filter(Boolean);
};

const FollowUpForm = ({
  object,
  images,
  address,
  handleIntermediateFollowUpSubmit,
  handleFinalFollowUpSubmit,
  nextQuestion,
  questions_answers,
  clearForm,
  questionsCount,
  isFinalQuestion,
  propertyType,
  aiSuggestions
}) => {
  const { t, language } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [creatingAd, setCreatingAd] = useState(false);
  const [answerInput, setAnswerInput] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const [validationError, setValidationError] = useState('');
  const [characterCount, setCharacterCount] = useState(0);
  const history = useHistory();
  const chatBoxRef = useRef(null);
  const inputRef = useRef(null);
  const suggestionsRef = useRef([]);

  // Validation constants
  const MAX_ANSWER_LENGTH = 2000;
  const MIN_ANSWER_LENGTH = 1;
  const WARNING_LENGTH = 1800;

  // Helper to anonymize address by stripping house number
  const anonymizedAddress = address ? address.replace(/\s+\d+.*$/, '') : '';

  // Sanitization function to prevent XSS
  const sanitizeInput = (input) => {
    if (!input) return '';
    
    // Remove script tags and other dangerous HTML
    let sanitized = input.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    sanitized = sanitized.replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '');
    sanitized = sanitized.replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, '');
    sanitized = sanitized.replace(/<embed\b[^<]*(?:(?!<\/embed>)<[^<]*)*<\/embed>/gi, '');
    sanitized = sanitized.replace(/<form\b[^<]*(?:(?!<\/form>)<[^<]*)*<\/form>/gi, '');
    
    // Remove javascript: and data: protocols
    sanitized = sanitized.replace(/javascript:/gi, '');
    sanitized = sanitized.replace(/data:/gi, '');
    
    // Remove on* event handlers
    sanitized = sanitized.replace(/\son\w+\s*=\s*["'][^"']*["']/gi, '');
    
    // Limit to reasonable characters (allow Swedish characters)
    sanitized = sanitized.replace(/[^\p{L}\p{N}\p{P}\p{Z}\p{S}]/gu, '');
    
    return sanitized.trim();
  };

  // Validation function
  const validateAnswer = (input) => {
    const sanitized = sanitizeInput(input);
    
    if (sanitized.length < MIN_ANSWER_LENGTH) {
      return { isValid: false, error: t('followUp.validationMin') };
    }
    
    if (sanitized.length > MAX_ANSWER_LENGTH) {
      return { isValid: false, error: t('followUp.validationMax', { max: MAX_ANSWER_LENGTH }) };
    }
    
    // Check for suspicious patterns
    const suspiciousPatterns = [
      /<script/i,
      /javascript:/i,
      /onclick/i,
      /onerror/i,
      /onload/i,
      /<iframe/i,
      /<object/i,
      /<embed/i
    ];
    
    for (const pattern of suspiciousPatterns) {
      if (pattern.test(sanitized)) {
        return { isValid: false, error: t('followUp.validationUnsafe') };
      }
    }
    
    return { isValid: true, sanitized };
  };

  // Handle input change with validation
  const handleAnswerInputChange = (e) => {
    const rawValue = e.target.value;
    const validation = validateAnswer(rawValue);
    
    if (validation.isValid || rawValue === '') {
      setAnswerInput(rawValue);
      setCharacterCount(rawValue.length);
      setValidationError('');
      
      if (rawValue.trim()) {
        setShowSuggestions(false);
      } else {
        setShowSuggestions(suggestions.length > 0);
      }
    } else {
      // For invalid input, show error but don't update if it exceeds max length
      if (rawValue.length > MAX_ANSWER_LENGTH) {
        setValidationError(validation.error);
      } else {
        setAnswerInput(rawValue);
        setCharacterCount(rawValue.length);
        setValidationError(validation.error);
      }
    }
  };

  // Reset suggestion refs when the number of suggestions changes
  useEffect(() => {
    suggestionsRef.current = suggestionsRef.current.slice(0, (aiSuggestions || []).length);
  }, [aiSuggestions]);

  // Use AI suggestions if available, otherwise fall back to static suggestions
  const suggestions = useMemo(() => {
    if (aiSuggestions && aiSuggestions.length > 0) {
      return aiSuggestions;
    } else {
      return localizeStaticSuggestions(getStaticSuggestions(propertyType, nextQuestion), language);
    }
  }, [aiSuggestions, propertyType, nextQuestion, language]);

  // Handle suggestion visibility and reset index
  useEffect(() => {
    if (showSuggestions) {
      scrollToBottom(100);
    }
    if (!showSuggestions) {
      setActiveSuggestionIndex(-1);
    }
  }, [showSuggestions]);

  // Extract property type from questions if not provided
  const getPropertyTypeFromQuestions = () => {
    if (propertyType) return propertyType;
    if (questions_answers) {
      const lowerQA = questions_answers.toLowerCase();
      if (lowerQA.includes("lägenhet")) return "Lägenhet";
      if (lowerQA.includes("villa")) return "Villa";
      if (lowerQA.includes("fritidshus")) return "Fritidshus";
      if (lowerQA.includes("radhus")) return "Radhus";
      if (lowerQA.includes("parhus")) return "Parhus";
      if (lowerQA.includes("kedjehus")) return "Kedjehus";
    }
    return "";
  };

  // Generate static suggestions as fallback
  const getStaticSuggestions = (currentPropertyType, question) => {
    if (!question) return [];
    const lowerQuestion = question.toLowerCase();

    const commonSuggestions = {
      renovation: [
        'Ja, hela bostaden renoverades för 3 år sedan',
        'Köket renoverades 2020 och badrummet 2022',
        'Inga större renoveringar har gjorts nyligen',
        'Delvis renoverat - kök och badrum är i originalskick'
      ],
      area: [
        'Bostaden har bra planlösning med öppna ytor',
        'Den är ljus med stora fönster i vardagsrummet',
        'Köket är nyligen renoverat med modern standard',
        'Den har en praktisk planlösning med bra förvaring'
      ],
      neighborhood: [
        'Området är lugnt och barnvänligt med nähet till skolor',
        'Det finns bra kommunikationer med bussar och tunnelbana',
        'Det är nära till matbutiker och service',
        'Området har många grönområden och parker'
      ],
      costs: [
        'Driftskostnaderna är ca 3000-4000 kr per månad',
        'El, värme och vatten kostar ca 2500 kr per månad',
        'Jag uppskattar att driftskostnaderna är normala för denna typ av bostad',
        'Förra årets totala driftskostnader var ca 30 000 kr'
      ]
    };

    if (currentPropertyType === "Lägenhet") {
      if (lowerQuestion.includes("balkong") || lowerQuestion.includes("uteplats")) {
        return [
          'Ja, det finns en balkong i söderläge med plats för möbler',
          'Lägenheten har en inglasad balkong på 6 kvm',
          'Nej, det finns ingen balkong eller uteplats',
          'Det finns en gemensam innergård med utemöbler'
        ];
      }
      if (lowerQuestion.includes("avgift") || lowerQuestion.includes("månadsavgift")) {
        return [
          'Månadsavgiften är 3500 kr och inkluderar värme och vatten',
          'Avgiften är 4200 kr och inkluderar bredband och kabel-TV',
          'Månadsavgiften är 2800 kr, exklusive el',
          'Avgiften på 3900 kr inkluderar alla nödvändiga kostnader'
        ];
      }
      if (lowerQuestion.includes("förening") || lowerQuestion.includes("bostadsrättsförening")) {
        return [
          'Föreningen är ekonomiskt stabil med låg belåning',
          'Det finns inga planerade avgiftshöjningar',
          'Föreningen äger marken och har god ekonomi',
          'Föreningen har nyligen genomfört stambyten och takrenovering'
        ];
      }
    } else if (["Villa", "Radhus", "Parhus", "Kedjehus"].includes(currentPropertyType)) {
      if (lowerQuestion.includes("tomt") || lowerQuestion.includes("trädgård")) {
        return [
          'Tomten är 850 kvm med en välskött trädgård',
          'Det finns en stor trädgård med fruktträd och planteringar',
          'Trädgården är lättskött med gräsmatta och stenlagd uteplats',
          'Tomten är hörntomt på 1200 kvm med soligt läge'
        ];
      }
      if (lowerQuestion.includes("garage") || lowerQuestion.includes("parkering")) {
        return [
          'Ja, det finns ett garage med plats för en bil plus uppfart',
          'Det finns carport med plats för två bilar',
          'Nej, men det finns gott om parkeringsmöjligheter på gatan',
          'Ja, det finns ett fristående dubbelgarage på tomten'
        ];
      }
      if (lowerQuestion.includes("uppvärmning") || lowerQuestion.includes("energi")) {
        return [
          'Huset värms upp med fjärrvärme, energiklass C',
          'Det finns bergvärme installerad 2019 som ger låga driftskostnader',
          'Luftvärmepump kompletterar direktverkande el för uppvärmning',
          'Huset har vattenburen golvvärme på nedervåningen'
        ];
      }
    } else if (currentPropertyType === "Fritidshus") {
      if (lowerQuestion.includes("vinterbonat") || lowerQuestion.includes("året runt")) {
        return [
          'Ja, huset är vinterbonat och kan användas året runt',
          'Delvis, men uppvärmningskostnaderna blir höga på vintern',
          'Nej, det är främst ett sommarhus med enkel standard',
          'Huset har förstärkts isolering och nya fönster för åretruntbruk'
        ];
      }
      if (lowerQuestion.includes("vatten")) {
        return [
          'Det är 200 meter till stranden med egen båtplats',
          'Fritidshuset ligger precis vid sjön med egen brygga',
          'Tomten gränsar till havet med fantastisk utsikt',
          'Det är cirka 500 meter till närmaste badplats'
        ];
      }
      if (lowerQuestion.includes("avlopp") || lowerQuestion.includes("vatten och avlopp")) {
        return [
          'Det finns kommunalt vatten men eget avlopp med trekammarbrunn',
          'Huset har egen brunn och infiltrationsanläggning från 2018',
          'Det är anslutit till kommunalt vatten och avlopp',
          'Det finns sommarvatten indraget men torrtoa'
        ];
      }
    }

    if (lowerQuestion.includes("renover")) return commonSuggestions.renovation;
    if (lowerQuestion.includes("område") || lowerQuestion.includes("närområde") || lowerQuestion.includes("närhet")) {
      return commonSuggestions.neighborhood;
    }
    if (lowerQuestion.includes("kostnad") || lowerQuestion.includes("drift") || lowerQuestion.includes("pris")) {
      return commonSuggestions.costs;
    }
    if (lowerQuestion.includes("skick") || lowerQuestion.includes("standard")) {
      return [
        'Bostaden är i mycket gott skick utan renoveringsbehov',
        'Det finns visst renoveringsbehov i badrum och kök',
        'Allt är välskött men i äldre standard',
        'Bostaden håller genomgående hög standard'
      ];
    }

    return [
      'Ja, det stämmer',
      'Nej, det stämmer inte',
      'Jag är osäker på det',
      'Kan du specificera frågan lite mer?'
    ];
  };

  // Scroll to bottom helper
  const scrollToBottom = (delay = 300) => {
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }, delay);
  };

  // Submit intermediate answer
  const onClickSubmit = async () => {
    const validation = validateAnswer(answerInput);
    
    if (!validation.isValid) {
      setValidationError(validation.error);
      return;
    }
    
    if (!validation.sanitized.trim()) {
      setValidationError(t('followUp.validationEmpty'));
      return;
    }
    
    setLoading(true);
    setValidationError('');
    
    try {
      await handleIntermediateFollowUpSubmit(validation.sanitized, nextQuestion);
      
      // Track intermediate follow-up form submission
      trackFormSubmission('intermediate_followup_form', {
        property_type: propertyType,
        question_count: questionsCount
      });
      
      setAnswerInput('');
      setCharacterCount(0);
      setShowSuggestions(false);
      scrollToBottom();
    } catch (error) {
      console.error('Error in FollowUpForm onSubmit:', error);
      setValidationError(t('followUp.submitError'));
    } finally {
      setLoading(false);
    }
  };

  // Submit final answer
  const onClickFinalSubmit = async () => {
    // Kontrollera om det är sista frågan med bredare matchning
    const isFinalPrompt = 
      isFinalQuestion || 
      (nextQuestion && (
        nextQuestion.toLowerCase().includes("tack för all information") || 
        nextQuestion.toLowerCase().includes("innan jag sammanställer annonsen") ||
        nextQuestion.toLowerCase().includes("något mer du vill lägga till")
      ));
    
    // Om det är sista frågan och tomt svar, använd standardsvar
    const finalAnswer = isFinalPrompt && !answerInput.trim() 
      ? t('followUp.finalDefault')
      : answerInput;
    
    const validation = validateAnswer(finalAnswer);
    
    if (!validation.isValid) {
      setValidationError(validation.error);
      return;
    }
      
    if (!validation.sanitized.trim()) {
      setValidationError(t('followUp.validationEmpty'));
      return;
    }
    
    try {
      setLoading(true);
      setCreatingAd(true);
      setValidationError('');
      await handleFinalFollowUpSubmit(validation.sanitized, nextQuestion);
      
      // Track final follow-up form submission (main conversion event)
      trackFormSubmission('final_followup_form', {
        property_type: propertyType,
        question_count: questionsCount,
        is_final_question: isFinalQuestion
      });
      
      setAnswerInput('');
      setCharacterCount(0);
    } catch (error) {
      console.error('Error in FollowUpForm onSubmit:', error);
      setValidationError(t('followUp.createError'));
    }
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (showSuggestions && suggestions.length > 0) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveSuggestionIndex(prev => prev <= 0 ? suggestions.length - 1 : prev - 1);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveSuggestionIndex(prev => prev >= suggestions.length - 1 ? 0 : prev + 1);
      } else if (e.key === "Enter") {
        if (activeSuggestionIndex >= 0 && activeSuggestionIndex < suggestions.length) {
          e.preventDefault();
          handleSuggestionClick(suggestions[activeSuggestionIndex]);
        } else if (answerInput.trim() && !validationError) {
          e.preventDefault();
          isFinalQuestion ? onClickFinalSubmit() : onClickSubmit();
        }
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
        setActiveSuggestionIndex(-1);
      }
    } else if (e.key === "Enter" && answerInput.trim() && !validationError) {
      e.preventDefault();
      isFinalQuestion ? onClickFinalSubmit() : onClickSubmit();
    }
  };

  // Determine if this is the final question
  const determineIfFinalQuestion = () => {
    if (isFinalQuestion) return true;
    const MIN_QUESTIONS = 2;
    if (questionsCount >= MIN_QUESTIONS) {
      const qaBoxes = questions_answers ? createQABoxes(questions_answers) : [];
      let totalAnswerLength = qaBoxes.reduce((sum, qa) => sum + (qa.answer || '').length, 0);
      if (totalAnswerLength > 600 || questionsCount >= 8) return true;
    }
    return false;
  };

  // Parse questions_answers into Q/A pairs
  const createQABoxes = (str) => {
    if (!str) return [];
    const lines = str.split('\n').filter(line => line.trim());
    const pairs = [];
    for (let i = 0; i < lines.length; i += 2) {
      pairs.push({
        question: lines[i],
        answer: lines[i + 1] || ''
      });
    }
    return pairs;
  };

  // Handle home button click
  const handleHomeClick = async () => {
    try {
      setLoading(true);
      // Delete the current incomplete object data
      await axios.delete(`${config.backend_url}/api/delete-latest-seller-data`, {
        withCredentials: true
      });
      await clearForm();
      history.push('/');
    } catch (error) {
      console.error('Error cancelling form:', error);
      await clearForm();
      history.push('/');
    } finally {
      setLoading(false);
    }
  };

  // Handle suggestion selection
  const handleSuggestionClick = (suggestion) => {
    const validation = validateAnswer(suggestion);
    if (validation.isValid) {
      setAnswerInput(validation.sanitized);
      setCharacterCount(validation.sanitized.length);
      setValidationError('');
    } else {
      setAnswerInput(suggestion.substring(0, MAX_ANSWER_LENGTH));
      setCharacterCount(suggestion.substring(0, MAX_ANSWER_LENGTH).length);
      setValidationError('');
    }
    setShowSuggestions(false);
    setActiveSuggestionIndex(-1);
    inputRef.current?.focus();
  };

  // Show suggestions on input focus
  const handleInputFocus = () => {
    if (suggestions.length > 0) {
      setShowSuggestions(true);
      scrollToBottom(100);
    }
  };

  // Hide suggestions on blur, unless clicking a suggestion
  const handleInputBlur = (e) => {
    const relatedTarget = e.relatedTarget;
    if (!relatedTarget || !relatedTarget.classList.contains('suggestion')) {
      setTimeout(() => setShowSuggestions(false), 150);
    }
  };

  const qaBoxes = createQABoxes(questions_answers);
  const isFinal = determineIfFinalQuestion();

  // Calculate progress
  const minQuestions = 2;
  const maxQuestions = 4;
  const calculateProgress = () => {
    const baseProgress = 50;
    let additionalProgress = 0;
    if (questionsCount > 0) {
      additionalProgress = (Math.min(questionsCount, maxQuestions) / maxQuestions) * 50;
    }
    return baseProgress + additionalProgress;
  };

  // Add CSS class for animated dots
  useEffect(() => {
    if (!loading) {
      setCreatingAd(false);
    }
  }, [loading]);

  return (
    <div className="conversation-container">
      {/* Main Progress Indicator */}
      <div className="main-step-indicator">
        <span className="step-text">{t('followUp.step')}</span>
        <div className="step-progress">
          <div className="step-progress-dot"></div>
          <div className="step-progress-dot active"></div>
          <div className="step-progress-dot"></div>
        </div>
      </div>

      {/* Detailed Question Progress bar */}
      <div className="progress-container">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${calculateProgress()}%` }}
          ></div>
        </div>
        <div className="progress-text">
          {isFinal ? t('followUp.finalQuestion') : t('followUp.questionProgress', { current: questionsCount + 1, total: maxQuestions })}
        </div>
      </div>

      {/* Property info section with skip button */}
      <div className="property-info">
      <h3>{t('followUp.title')}</h3>
        <p style={{ fontSize: '18px' }}>
          {t('followUp.intro', { address: anonymizedAddress })}
        </p>
        {images && images.length > 0 && (
          <div className="images-gallery">
            {images.map((img, index) => {
              const src = typeof img === 'string' ? img : URL.createObjectURL(img);
              return (
                <img
                  key={index}
                  src={src}
                  alt={`uploaded-${index}`}
                  className="property-image"
                />
              );
            })}
          </div>
        )}
      </div>

      {/* Chat conversation section */}
      <div className="chat-container">
        <div
          className="chat-box"
          ref={chatBoxRef}
          style={{ minHeight: "250px" }}
        >
          {/* Assistant greeting */}
          {/* Render previous Q/A pairs */}
          {qaBoxes.map(({ question, answer }, index) => (
            <React.Fragment key={index}>
              <div className="message assistant-message">
                <div className="message-avatar">Bodex</div>
                <div className="message-content">
                  <p style={{ fontSize: '18px' }}>{question}</p>
                </div>
              </div>
              {answer && (
                <div className="message user-message">
                  <div className="message-avatar">{t('followUp.you')}</div>
                  <div className="message-content">{answer}</div>
                </div>
              )}
            </React.Fragment>
          ))}

          {/* Current question */}
          {nextQuestion && (
            <div className="message assistant-message" id="current-question">
              <div className="message-avatar">Bodex</div>
              <div className="message-content">
                <p style={{ fontSize: '18px' }}>{nextQuestion}</p>
              </div>
            </div>
          )}
        </div>

        {/* Input section */}
        <div className="chat-input-container">
          {showSuggestions && suggestions.length > 0 && (
            <div className="suggestions-container">
              <div
                className="answer-suggestions"
                id="suggestions-list"
                role="listbox"
              >
                {suggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    id={`suggestion-${index}`}
                    ref={el => suggestionsRef.current[index] = el}
                    className={`suggestion ${index === activeSuggestionIndex ? 'active' : ''}`}
                    onClick={() => handleSuggestionClick(suggestion)}
                    onMouseDown={e => e.preventDefault()}
                    tabIndex="0"
                    role="option"
                    aria-selected={index === activeSuggestionIndex}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Validation error message */}
          {validationError && (
            <div className="validation-error" style={{
              color: '#e74c3c',
              fontSize: '14px',
              margin: '5px 0',
              padding: '5px',
              backgroundColor: '#fdf2f2',
              border: '1px solid #fbb8b8',
              borderRadius: '4px'
            }}>
              {validationError}
            </div>
          )}

          <textarea
            className="chat-input"
            ref={inputRef}
            value={answerInput}
            onChange={handleAnswerInputChange}
            onKeyDown={handleKeyDown}
            placeholder={t('followUp.placeholder')}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            aria-controls={showSuggestions ? "suggestions-list" : undefined}
            aria-expanded={showSuggestions}
            aria-activedescendant={activeSuggestionIndex >= 0 ? `suggestion-${activeSuggestionIndex}` : undefined}
            maxLength={MAX_ANSWER_LENGTH}
            style={{
              borderColor: validationError ? '#e74c3c' : characterCount >= WARNING_LENGTH ? '#f39c12' : '#ddd'
            }}
          />

          {/* Character count */}
          <div className="character-count" style={{
            fontSize: '12px',
            color: characterCount >= WARNING_LENGTH ? '#f39c12' : '#888',
            textAlign: 'right',
            margin: '2px 0'
          }}>
            {t('followUp.characters', { count: characterCount, max: MAX_ANSWER_LENGTH })}
          </div>

          <div className="button-container">
            {loading && !creatingAd ? (
              <div className="spinner-container">
                <Spinner />
              </div>
            ) : (
              <button
                className={`submit-button ${isFinal ? 'final-button' : ''}`}
                onClick={isFinal ? onClickFinalSubmit : onClickSubmit}
                disabled={
                  !!validationError || 
                  (isFinal && (
                    nextQuestion.toLowerCase().includes("tack för all information") || 
                    nextQuestion.toLowerCase().includes("innan jag sammanställer annonsen") ||
                    nextQuestion.toLowerCase().includes("något mer du vill lägga till") ||
                    isFinalQuestion
                  ) ? false : !answerInput.trim())
                }
              >
                {isFinal ? t('common.createAd') : t('followUp.answer')}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Add the SpinnerOverlay with creatingAd prop */}
      {loading && creatingAd && <SpinnerOverlay creatingAd={true} />}
    </div>
  );
};

export default FollowUpForm;
